const INITIAL_STATE = {
  esperandoSolicitacao: false,
  beneficioSelecionado: null,
  retornoRequerimento: null,
  beneficios: null,
  temVagasPman: false,
  alerta: {},
};

export default (state = INITIAL_STATE, action) => {

  switch (action.type) {
    case 'REQUERIMENTO_PRORROGACAO_VALIDAR_SIBE_INICIAR':
    case 'REQUERIMENTO_PRORROGACAO_CONCLUIR_PEDIDO_INICIAR':
      return { ...state, esperandoSolicitacao: true, alerta: {}, retornoRequerimento: null };
    case 'REQUERIMENTO_PRORROGACAO_VALIDAR_SIBE_SUCESSO':
    case 'REQUERIMENTO_PRORROGACAO_CONCLUIR_PEDIDO_FINALIZAR':
      return {
        ...state,
        esperandoSolicitacao: false,
        alerta: {}
      }
    case 'REQUERIMENTO_PRORROGACAO_ATUALIZA_CAMPOS_SUCESSO':
      return {
        ...state,
        esperandoSolicitacao: false,
        alerta: {},
        retornoRequerimento: {
          ...state.retornoRequerimento,
          dadosAdicionais: action.payload
        }
      }
    case 'REQUERIMENTO_PRORROGACAO_VALIDAR_SIBE_ERRO':
      return { ...state, esperandoSolicitacao: false, alerta: { message: action.payload, severity: 'error' } }
    case 'REQUERIMENTO_PRORROGACAO_SELECIONAR_BENEFICIO':
      return { ...state, esperandoSolicitacao: false, beneficioSelecionado: action.payload };
    case 'REQUERIMENTO_PRORROGACAO_EXIBIR_ALERTA':
      return { ...state, esperandoSolicitacao: false, alerta: action.payload }
    case 'REQUERIMENTO_PRORROGACAO_FECHAR_ALERTA':
    case 'REQUERIMENTO_PRORROGACAO_ATUALIZA_CAMPOS_ERRO':
      return { ...state, esperandoSolicitacao: false, alerta: {} };
    case 'REQUERIMENTO_PRORROGACAO_SET_RETORNO':
      return { ...state, alerta: {}, retornoRequerimento: action.payload }
    case 'CONSULTAR_LISTA_BENEFICIOS_PARA_PRORROGACAO_INICIAR':{
      return {...state, esperandoSolicitacao: true}
    }
    case 'CONSULTAR_LISTA_BENEFICIOS_PARA_PRORROGACAO_FIM': 
      return {...state, esperandoSolicitacao: false }
    case 'CONSULTAR_LISTA_BENEFICIOS_PARA_PRORROGACAO_SUCESSO':
      return {...state, esperandoSolicitacao: false, beneficios: action.payload}
    case 'CONSULTAR_LISTA_BENEFICIOS_PARA_PRORROGACAO_ERRO':
      return {...state, esperandoSolicitacao: false, alerta: action.payload}

    case 'PRORROGACAO_TEM_VAGAS_PMAN':
      return {...state, temVagasPman: action.payload}
    
    default:
      return state;
  }

}